import { createSelector } from '@ngrx/store';
import { createSortStateSelector } from '../create-sort-state-selector/create-sort-state.selector';
import { SortDirectionType } from '../../../../../models';

export function selectorBody(orderedDataIds: string[], sortDirection: SortDirectionType): string[] {
  if (!orderedDataIds || !sortDirection) {
    return [];
  }

  return sortDirection === 'DSC' ? orderedDataIds.slice().reverse() : orderedDataIds;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createOrderedDataIdsSelector = (filterInstanceId: string) =>
  createSelector(createSortStateSelector(filterInstanceId), (sortState) =>
    selectorBody(sortState?.orderedDataIds, sortState?.sortDirection)
  );
